// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M2 2H22V22L2 22V2ZM4 4V20L20 20V4H4ZM13 6.5V11H17.5V13H13V17.5H11V13L6.5 13V11L11 11V6.5H13Z"}}]};

const AddRectangleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'add-rectangle',
    ref,
    icon: element,
  },
));

AddRectangleIcon.displayName = 'AddRectangleIcon';

export default AddRectangleIcon;
